/* eslint-disable react/prop-types */
/* eslint-disable max-len */

/* eslint-disable react/react-in-jsx-scope */
import
React,
{ useMemo } from 'react';
import { Button } from 'reactstrap';
import { useHistory } from 'react-router-dom';

const PhotoFormatter = (value) => (
  <div>
    <img
      src={value}
      alt=""
      style={{
        width: '150px', height: 'auto', marginRight: '6px', borderRadius: '2px',
      }}
    />
  </div>
);

const partnerDetail = (history, info) => {
  history.push({
    pathname: `/admin/partner-detail/${info.id}`,
    state: { data: info },
  });
};

const ListDataPartner = (dataAPI) => {
  const history = useHistory();
  const columns = useMemo(
    () => [
      {
        Header: 'No',
        accessor: 'number',
        width: 20,
        disableGlobalFilter: true,
        disableSortBy: true,
      },
      {
        Header: 'Date',
        accessor: 'created_at',
        width: 20,
        disableGlobalFilter: true,
        disableSortBy: true,
      },
      {
        Header: 'Name',
        accessor: 'name',
        width: 110,
        Cell: ({ value }) => (
          <span>{value?.length > 35 ? `${value.substring(0, 35)}...` : value}</span>
        ),
      },
      {
        Header: 'Image',
        accessor: 'image',
        disableGlobalFilter: true,
        width: 110,
        Cell: ({ value }) => (
          <span>{value?.length > 20 ? `${value.substring(0, 20)}...` : value}</span>
        ),
      },
      {
        Header: 'Image',
        accessor: 'photo',
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 110,
      },
      {
        Header: 'Action',
        accessor: 'status',
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 110,
      },
    ], [],
  );

  const data = [];
  const rows = () => {
    for (let i = 0; i < dataAPI.length; i += 1) {
      data.push({
        id: dataAPI[i]?.id ?? '',
        number: `${i + 1}`,
        created_at: dataAPI[i]?.created_at,
        name: dataAPI[i]?.name ?? '',
        image: <a href={dataAPI[i]?.image} target="_blank" rel="noreferrer" style={{ marginRight: '6px' }}>{dataAPI[i]?.image?.slice(57)}</a>,
        photo: PhotoFormatter(`${dataAPI[i]?.image}`),
        status: [
          // eslint-disable-next-line no-loop-func
          // eslint-disable-next-line max-len
          (<Button key={dataAPI[i]?.id} color="outline-success" onClick={() => partnerDetail(history, dataAPI[i])}>Detail</Button>),
        ],
      });
    }
  };

  rows();
  const partnerListTableData = { tableHeaderData: columns, tableRowsData: data };
  return partnerListTableData;
};

export default ListDataPartner;
